import { render, staticRenderFns } from "./editSalesCataloge.vue?vue&type=template&id=99c98f14&scoped=true"
import script from "./editSalesCataloge.vue?vue&type=script&lang=js"
export * from "./editSalesCataloge.vue?vue&type=script&lang=js"
import style0 from "./editSalesCataloge.vue?vue&type=style&index=0&id=99c98f14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c98f14",
  null
  
)

export default component.exports